import BorrowerDashContent from './borrower-dash-content';

export default BorrowerDashContent;
